import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-dd297e26"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "notice-wrapper" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" 세금환급 서비스는 BNK경남은행의 제휴사인 ㈜혜움이 제공합니다. ")
const _hoisted_3 = /*#__PURE__*/_createTextVNode(" BNK경남은행은 세금환급 서비스 페이지 연결을 제공하며, 서비스 제공에 대한 모든 책임은 제휴사인 ㈜혜움에 있습니다. ")

import Text from '@/components/common/TextComponent.vue';
import { COLOR_SET } from '@/styles/variables';

export default /*#__PURE__*/_defineComponent({
  name: 'LandingNotice',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("ul", null, [
      _createElementVNode("li", null, [
        _createVNode(Text, {
          color: _unref(COLOR_SET).gray015,
          size: "14px"
        }, {
          default: _withCtx(() => [
            _hoisted_2
          ]),
          _: 1
        }, 8, ["color"])
      ]),
      _createElementVNode("li", null, [
        _createVNode(Text, {
          color: _unref(COLOR_SET).gray015,
          size: "14px"
        }, {
          default: _withCtx(() => [
            _hoisted_3
          ]),
          _: 1
        }, 8, ["color"])
      ])
    ])
  ]))
}
}

})